import { useEffect, useState } from "react";

// ─── Dispatch a style command into the signature ──────────────────────────────

export function dispatchSignatureStyle(command: string, value: string) {
  document.dispatchEvent(
    new CustomEvent("signature:style", { detail: { command, value } }),
  );
}

// ─── Hook: returns true when the current selection is inside a signature ──────

export function useIsSignatureActive(): boolean {
  const [active, setActive] = useState(false);

  useEffect(() => {
    const check = () => {
      const sel = window.getSelection();
      if (!sel || sel.rangeCount === 0) {
        setActive(false);
        return;
      }
      const node = sel.anchorNode;
      // Signature divs have data-signature="true" — see SignatureDecorator
      const inside =
        !!(node as HTMLElement)?.closest?.('[data-signature="true"]') ||
        !!node?.parentElement?.closest('[data-signature="true"]');
      setActive(inside);
    };
    document.addEventListener("selectionchange", check);
    return () => document.removeEventListener("selectionchange", check);
  }, []);

  return active;
}
